/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use element symbols with a capital first letter (Na, Cl, Fe), numbers for counts (H2O), parentheses for groups (Ca(OH)2) and a middle dot or period for hydrates (CuSO4·5H2O).`)
};

const es_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa símbolos de elementos con la primera letra en mayúscula (Na, Cl, Fe), números para las cantidades (H2O), paréntesis para grupos (Ca(OH)2) y un punto medio o punto para hidratos (CuSO4·5H2O).`)
};

const de_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie Elementsymbole mit großem Anfangsbuchstaben (Na, Cl, Fe), Zahlen für Anzahlen (H2O), Klammern für Gruppen (Ca(OH)2) und einen Multiplikationspunkt für Hydrate (CuSO4·5H2O).`)
};

const nl_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik elementsymbolen met een hoofdletter als eerste letter (Na, Cl, Fe), getallen voor aantallen (H2O), haakjes voor groepen (Ca(OH)2) en een middenpunt of punt voor hydraten (CuSO4·5H2O).`)
};

const fr_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les symboles chimiques avec une majuscule initiale (Na, Cl, Fe), des nombres pour les quantités (H2O), des parenthèses pour les groupes (Ca(OH)2) et un point médian pour les hydrates (CuSO4·5H2O).`)
};

const it_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i simboli degli elementi con la prima lettera maiuscola (Na, Cl, Fe), numeri per le quantità (H2O), parentesi per i gruppi (Ca(OH)2) e un punto centrale o un punto per gli idrati (CuSO4·5H2O).`)
};

const pt_br2_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use símbolos de elementos com a primeira letra maiúscula (Na, Cl, Fe), números para as contagens (H2O), parênteses para grupos (Ca(OH)2) e um ponto central ou ponto final para hidratos (CuSO4·5H2O).`)
};

const pt_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use símbolos de elementos com a primeira letra maiúscula (Na, Cl, Fe), números para as quantidades (H2O), parênteses para grupos (Ca(OH)2) e um ponto médio ou ponto final para hidratos (CuSO4·5H2O).`)
};

const ja_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先頭を大文字にした元素記号 (Na, Cl, Fe) を使い、個数は数字 (H2O)、グループには括弧 (Ca(OH)2)、水和物には中点またはピリオド (CuSO4·5H2O) を使います。`)
};

const zh_mw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用首字母大写的元素符号（Na、Cl、Fe），用数字表示原子数（H2O），用括号表示基团（Ca(OH)2），用居中点或句点表示水合物（CuSO4·5H2O）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_a2", locale)
	if (locale === "en") return en_mw_faq_a2(inputs)
	if (locale === "es") return es_mw_faq_a2(inputs)
	if (locale === "de") return de_mw_faq_a2(inputs)
	if (locale === "nl") return nl_mw_faq_a2(inputs)
	if (locale === "fr") return fr_mw_faq_a2(inputs)
	if (locale === "it") return it_mw_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_a2(inputs)
	if (locale === "pt") return pt_mw_faq_a2(inputs)
	if (locale === "ja") return ja_mw_faq_a2(inputs)
	return zh_mw_faq_a2(inputs)
};